// interface is not complete, feel free to complete required properties
import { SUBSCRIPTION_PERIOD } from './constants/config';

export interface User {
  id: number,
  name: string,
  image: string,
  streamer: boolean,
  v2_access: boolean,
  created_at: string,

  subscription?: {
    plan: number;
    days_left?: number,
    renewable: boolean,
    interval: SUBSCRIPTION_PERIOD,
    trial?: {
      trial_streaming_duration_left: number;
      days_used: number;
      length: number;
      expired: boolean;
    }
  }
  studio: { id: number },
}

export enum QueryParams {
  ORIGIN = 'origin',
  CUSTOM_LANDING = 'custom_landing',
  MODE = 'mode',
  ACTION = 'action',
}

export enum QueryParamsActions {
  CANCEL_SUBSCRIPTION= 'cancel-subscription',
}

export interface QueryParamsScheme extends Record<QueryParams, unknown> {
  [QueryParams.ACTION]: QueryParamsActions.CANCEL_SUBSCRIPTION;
  [QueryParams.MODE]: 'popup';
  [QueryParams.CUSTOM_LANDING]: string;
  [QueryParams.ORIGIN]: string;
}
